export const types = {
    NAVIGATE: 'NAVIGATE',
    ENDPROCESS:'ENDPROCESS'
};